export default {
      id: "logo-usage",
      viewBox: "0 0 224 47",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#logo",
      toString: function () {
        return this.url;
      }
    }